import { CONFIG } from 'config';

export class ViewSDKClient {
  constructor() {
    this.readyPromise = new Promise((resolve) => {
      if (window.AdobeDC) {
        resolve();
      } else {
        document.addEventListener("adobe_dc_view_sdk.ready", () => {
          resolve();
        });
      }
    });
    this.adobeDCView = undefined;
  }

  ready() {
    return this.readyPromise;
  }

  previewFile(divId, viewerConfig, blob, filename) {
    const config = {
      clientId: CONFIG.adobePDFPreviewKey,
    };
    if (divId) {
      config.divId = divId;
    }
    const filePromise = Promise.resolve(blob.arrayBuffer())
    this.adobeDCView = new window.AdobeDC.View(config);
    return this.adobeDCView.previewFile({
      content: {
        promise: filePromise,
      },
      metaData: {
        fileName: filename,
        id: "6d07d124-ac8",
      }
    }, viewerConfig);
  }

  previewFileUsingFilePromise(divId, filePromise, fileName) {
    this.adobeDCView = new window.AdobeDC.View({
      clientId: CONFIG.adobePDFPreviewKey,
      divId,
    });
    this.adobeDCView.previewFile({
      content: {
        promise: filePromise,
      },
      metaData: {
        fileName
      }
    }, {});
  }

  registerSaveApiHandler() {
    const saveApiHandler = (metaData) => new Promise(resolve => {
        setTimeout(() => {
          const response = {
            code: window.AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
            data: {
              metaData: Object.assign(metaData, { updatedAt: new Date().getTime() })
            },
          };
          resolve(response);
        }, 2000);
      });
    this.adobeDCView.registerCallback(
      window.AdobeDC.View.Enum.CallbackType.SAVE_API,
      saveApiHandler,
      {}
    );
  }

  registerEventsHandler(eventCallBack) {
    this.adobeDCView.registerCallback(
      window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
      (event) => {
        // we could add tracking to pdf viewing later if needed
        if (eventCallBack) {
          eventCallBack(event);
        }
      },
      {
        listenOn: [
          window.AdobeDC.View.Enum.Events.APP_RENDERING_START,
          window.AdobeDC.View.Enum.Events.APP_RENDERING_FAILED,
          window.AdobeDC.View.Enum.Events.APP_RENDERING_DONE,
          window.AdobeDC.View.Enum.Events.UNSUPPORTED_FEATURE_FOUND,
        ],
        enablePDFAnalytics: true,
      }
    );
  }
}